import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { InputTextBox } from "../../../../components";
import { OffStatus, OnStatus, SearchBlack, SettingIcon } from "../../../../components/Icons/Icons";
import axiosClient from "../../../../services/axiosClient";
import styles from "./ListCamera.module.css";
import EmptyImage from '../../../../assets/images/Emty.png';
import { sorterArrayChildIsManyObj } from "../../../../utils";

const cx = classNames.bind(styles)
const dataService = [
    'Chuyển động',
    'Nhận diện mặt'
]
function ListCamera({ onClickSetting, showModalMore }) {
    const [listCameraInWareHouse, setListCameraInWareHouse] = useState()
    const [textSearch, setTextSearch] = useState()
    const [toggleSort, setToggleSort] = useState(false)
    const [dataTable, setDataTable] = useState()
    const [method, setMethod] = useState('')
    const data = useParams()
    useEffect(() => {
        if (data.id) {
            const getListCamera = async (code) => {
                let params = {}
                if (textSearch) {
                    params = {
                        camera_name: textSearch,
                    }
                }
                const res = await axiosClient.get(`/cameraManagement/get-list-camera/?warehouse_code=${code}`, {
                    params
                })
                setListCameraInWareHouse(res.data)
            }
            getListCamera(data.id)
        }
    }, [data.id, textSearch])

    const handleChangeTextSearch = (data) => {
        setTextSearch(data)
    }

    useEffect(() => {
        const newData = listCameraInWareHouse ? [...listCameraInWareHouse] : null
        if (newData && method.length > 0) {
            switch (toggleSort) {
                case 'up':
                    const dataSortUp = sorterArrayChildIsManyObj(newData, 'CAMERA', method)
                    setDataTable(dataSortUp)
                    break;
                case 'down':
                    const dataSortDown = sorterArrayChildIsManyObj(newData, 'CAMERA', method)
                    setDataTable(dataSortDown.reverse())
                    break;
                default:
                    setDataTable(newData)
                    break;
            }
        } else {
            setDataTable(newData)
        }
    }, [listCameraInWareHouse, toggleSort, method])

    const handleSort = (type, method) => {
        if (type !== toggleSort) {
            setToggleSort(type)
            setMethod(method)
        } else {
            setToggleSort(false)
            setMethod('')
        }
    }
    return (
        <div className={cx('list-camera')}>
            <div className={cx("search")}>
                <div className={cx("search-form")}>
                    <InputTextBox
                        style={{ paddingTop: 2 }}
                        type="text"
                        placeholder="Tìm kiếm"
                        className={cx("pd")}
                        value={textSearch}
                        onChange={handleChangeTextSearch}
                    />
                    <span className={cx("icon-search")}>
                        <SearchBlack />
                    </span>
                </div>
            </div>
            <div className={cx('table-container')}>
                <table className={cx('table')}>
                    <thead>
                        <tr className={cx('row-table')}>
                            <th className={cx('header-table', 'stt')}>STT</th>
                            <th className={cx('header-table', 'name-header')}>
                                {'Tên camera'}
                            </th>
                            <th className={cx('header-table')}>
                                <div className={cx('number-columns')}>
                                {'Trạng thái AI'}
                                </div>
                                
                            </th>
                            <th className={cx('header-table')}>
                                <div className={cx('number-columns')}>
                                    {'Nhóm camera'}
                                </div>
                            </th>
                            <th className={cx('header-table')}>
                                <div className={cx('number-columns')}>
                                    {'Địa điểm'}
                                </div>

                            </th>
                            <th className={cx('header-table')}>
                                <div className={cx('number-columns')}>
                                    {'Độ phân giải'}
                                </div>
                            </th>
                            <th className={cx('header-table')}>
                                <div className={cx('number-columns')}>
                                    {'Dịch vụ'}
                                </div>
                            </th>
                            <th className={cx('header-table')}>
                                <div className={cx('number-columns')}>Hành động</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataTable && dataTable.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className={cx('header-table', 'stt')}>{index + 1}</td>
                                    <td className={cx('header-table')}>
                                        <div className={cx('name-camera')}>
                                            {item.CAMERA.STATUS === 'On' ? <OnStatus /> : <OffStatus />}
                                            <span className={cx('name')}>{item.CAMERA.NAME_CAM}</span>
                                        </div>
                                    </td>
                                    <td className={cx('header-table')} >
                                        <div className={cx('number-columns')}>
                                            <span className={cx("hover")}>
                                                <div className={cx('ai')} style={item?.CAMERA?.AI_CONFIG === 'On' ? { color: '#0040FF' } : { color: '#FF3300' }}>AI</div>
                                                <div className={cx("tooltip")}>
                                                    {item?.CAMERA?.AI_CONFIG === "On" ? "Đang bật" : "Đang tắt"}
                                                </div>
                                            </span>
                                        </div>
                                    </td>
                                    <td className={cx('header-table')} onClick={() => showModalMore(item?.GROUP_NAME, 'group')}>
                                        <div className={cx('number-columns', 'group')}>{item.GROUP_NAME.length}</div>
                                    </td>
                                    <td className={cx('header-table')} >
                                        <div className={cx('address')}>
                                            {item.CAMERA.PROVINCE_NAME}
                                        </div>
                                    </td>
                                    <td className={cx('header-table')}>
                                        <div className={cx('number-columns')}>{item.CAMERA.MAIN_SOURCE}</div>
                                    </td>
                                    <td className={cx('header-table')} onClick={() => showModalMore(item?.AI, 'service')}>
                                        <div className={cx('number-columns')}>{item?.AI?.length}</div>
                                    </td>
                                    <td className={cx('header-table')}>
                                        <div className={cx('button-action', 'number-columns')} onClick={() => onClickSetting(item.CAMERA.CODE)}>
                                            <SettingIcon />
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                {(!listCameraInWareHouse || listCameraInWareHouse.length === 0) && (
                    <div className={cx('list-camera-empty')}>
                        <img src={EmptyImage} alt="Empty" />
                    </div>
                )}
            </div>
        </div>
    )
}

export default ListCamera;